let url = window.location.origin;
let https_url;
let xml_url;
let tataCard;
let otpOrgId;
let campaignJourney;
let docUploadPageLink;
let trackError;
let baseURLpartner = sessionStorage.getItem('spa-domain-name');
let fgpCookie = sessionStorage.getItem('cookie') == null ? '5' : sessionStorage.getItem('cookie');
let trackErrorContatctLink;


if (url.includes('localhost:4200')) {
    //https_url = `https://sbi-uat1.sbicard.com`;
    https_url = `https://sbi-devsit2.sbicard.com/`;
    //https_url = `https://tata-sit2.sbicard.com`;
} else if(baseURLpartner){
    https_url = baseURLpartner;
} else {
    https_url = window.location.origin;
}
export const base_https_url = https_url;

if (window.location.href && window.location.href.toLowerCase().includes('campaign')) {
    campaignJourney = true;
} else {
    campaignJourney = false;
}
export const IS_CAMPAIGN = campaignJourney;
sessionStorage.setItem('campaign',IS_CAMPAIGN);
if (base_https_url && base_https_url.toLowerCase().includes('tata')) {
    xml_url = `${base_https_url}/tata-content/cards/card-details.page?path=`;
    tataCard = true;
    otpOrgId = '201';
    docUploadPageLink = `${base_https_url}/tata-eapply/docupload.page`;
    trackError = `TATA Card credentials as entered by you are incorrect. Please try again or call up the SBI Card helpline on 39 02 02 02 (prefix your city code) or 1860 180 1290, 1800 180 1290 (only for MTNL and BSNL users)`;
    trackErrorContatctLink = `${base_https_url}/tata-en/contact-us/personal.page`;
} else {
    xml_url = `${base_https_url}/content/cards/card-details.page?path=`;
    otpOrgId = '101';
    docUploadPageLink = `${base_https_url}/eapply/docupload.page`;
    trackError= `SBI Card credentials as entered by you are incorrect. Please try again or call up the SBI Card helpline on 39 02 02 02 (prefix your city code) or 1860 180 1290, 1800 180 1290 (only for MTNL and BSNL users)`;
    trackErrorContatctLink = `${base_https_url}/en/contact-us/personal.page`;
}
export const DRC_XML_URL = xml_url;
export const ISTATACARD = tataCard;
export const DOC_UPLOAD_LINK = docUploadPageLink;
export const TRACKERROR_CONTACT_LINK = trackErrorContatctLink;
export const ALL_CARD_JSON_LINK = '../assets/mocks/allcards.json';
export const orgId = otpOrgId;
export const BRAND_APPROVED_ERRORS={
    panStatus300:`Sorry, something went wrong. We are working on getting this fixed as soon as we can. Please try again after some time.`,
    panDedupeAllowed:`An application with this PAN and mobile number already exists in our system. To track your previous application, <a href="/en/home.page#trackapp"> click here </a>`,
    invalidRequest:`We are unable to process your request further. An SBI Card executive will get in touch with you to schedule an appointment`,
    // appProccessBySales24:`Thank you for your interest in SBI Card. Your Application for <card type> has been processed. The final approval and the credit limit assigned would be subject to submission of requisite documents & their verification. `,
    appProccessBySales24:`Sorry we could not save your Add On details. Our representative will get in touch with you to capture the details.`,
    exceptionOccured:`Sorry, something went wrong. We are working on getting this fixed as soon as we can. Please try again after some time.`,
    duplicateRecord:`You appear to have applied recently. We do not allow you to submit multiple applications to prevent numerous enquiries on your bureau history. To check the status of your application, please click here. If you have any issues regarding your application, please reach out to customer care.`,
    CCFailure:`There was a problem while processing your request. Please try after sometime.`,
    // cardDeviationTrue:`An application with this PAN and Mobile Number for <CARD TYPE> is already saved.`,
    cardDeviationTrue:`You seem to have applied for an SBI Card earlier, to check the status of your application please go to track application on Homepage of <a href="/">www.SBICARD.com</a>`,
    // panNameMismatch:`Name provided by you is not matching with true provided PAN details .`,
    panNameMismatch:`Name provided by you does not match with your PAN.`,
    cardFetchError:`Sorry, there was a problem while fetching the cards. We are working on getting this fixed as soon as we can. Please try again after some time.`,
    panDedupeFound:`Application under this PAN  already exists.`

};
// Pandedupe New Multicarding Begins 
export const BRAND_APPROVED_PANDEDUPE_ERRORS={
    pandedupeErrorFound1:`Application with this PAN already exists in our system.`,
    pandedupeErrorFound2:`to track your existing application.`,
    pandedupeErrorFound3:`OR`,
    pandedupeErrorFound4:`It seems you are an existing SBI Card holder.`,
    pandedupeErrorFound5:`To Apply for another best suited SBI Credit Card, suggested to you basis your spending pattern, and`,
    pandedupeErrorFound6:`get your application processed without any document, Click on "Proceed".`,
    pandedupeErrorFound7:`Enter your Card Number, DOB and OTP to view your card options. Submit your application and get`,
    pandedupeErrorFound8:`your e-Card instantly`,
};
export const excludedReferPICardsCataloguePage = ['SBI Card Unnati','Tata Platinum Card','Tata Titanium Card'];
export const excludedReferEarnCardsCategories = ['Banking Partnership','Business'];
export const GENERIC_ERRORS = {
    otpError: 'Please verify your phone number.',
    leadGenerationSuccess: 'Data has been saved successfully.',
    error: `Sorry! You cannot avail this service at the moment. Please try again later or call the SBI Card helpline at 39 02 02 02 (prefix the STD code of your city).`,
    success: 'OTP validated successfully for existing user',
    // existingCustomerSaveSuccess1:'Thank you! Your interest for the ',
    existingCustomerSaveSuccess1:'Your interest for the ',
    existingCustomerSaveSuccess2:' has been registered. Our customer service executive will get in touch with you.',
    // 'Data has been saved for existing customer journey.'
    existingCustomerSaveFailure: 'Existing details not found.',
    otpSuccess: 'OTP validated successfully.',
    otpFailure: 'OTP validation failed.',
    sendOtpError: 'Otp can not be send now please try after some time',
    genError: `Sorry! You cannot avail this service at the moment. Please try again later or call the SBI Card helpline at 39 02 02 02 (prefix the STD code of your city).`,
    invalidPan: 'Please enter valid PAN details.'
}
export const verbiageList = {
    invalidOtp: 'Please enter valid OTP.',
    maxOtpAttempt: `You have exhausted the number of attempts for Resend OTP. Please restart your application.`,
    maxOtpValidate:`You have exhausted the number of attempts for OTP Authentication. Please restart your application.`
}
export const GENERIC_ERROR = `Sorry! You cannot avail this service at the moment. Please try again later or call the SBI Card helpline at 39 02 02 02 (prefix the STD code of your city).`;
export const VALIDATION_MSG = {
    cityNotFound:'Select city from list',
    mandatoryField: 'Field is mandatory.',
    ofcPhoneMinLength:`Sould have atleast 7 digits.`,
    invalidEmail: 'Invalid E-mail.',
    invalidMobile: 'Invalid phone no.',
    invalidPincodeDigit: 'Should have 6 digits.',
    maxlengthValidationCity: 'Should have 2 Characters.',
    //pincodeNotfound: 'We currently don' + 't serve this pincode.',
    pincodeNotfound: 'We do not provide services at your pin code. ',
    invalidPan: 'Invalid PAN',
    invalidCard: 'Invalid Card Number',
    maxlengthValidation: 'Should have 10 digits.',
    minLengthValidation: 'Should have 11 digits.',
    maxDigitrequired: 'Minimum 13 digits required',
    desiredLength: 'Should have 6 digits.',
    fullNameReqd: 'Full Name required',
    emailReqd: 'E-mail Address required',
    emailInvalid: 'E-mail is not valid',
    maxIncome:'Max income should be 20 crore.',
    invalidInput:'Invalid input',
    invalidname:'Only Alphabets allowed',
//  invalideReferralCodeMesssage: 'Invalid Referral-code',
    invalideReferralCodeMesssage:'Please enter valid referral code',
//  invalidRefferalCodeServiceFailure:'Unable to Validate Referral-code Now Please try again after sometime'
    invalidRefferalCodeServiceFailure:'Unable to verify referral code',
    //Added for Special character
    houseInvalid: 'Invalid character in resiAddressLine1',
    localityInvalid: 'Invalid character in resiAddressLine3',
    addressInvalid: 'Invalid character in resiAddressLine2',
    fatherNameInvalid: 'Invalid character in fathersName',
    motherMaidenInvalid: 'Invalid character in mother maiden name',
    address1Invalid: 'Invalid character in officeAddress1',
    address2Invalid: 'Invalid character in officeAddress2',
    landmarkInvalid: 'Invalid character in officeAddress3',
    fullNameInvalid: 'Invalid character in full name',
    ofcPhoneInvalid: 'Invalid character in phone number',
    invalidResiStatus: 'Invalid character in ResiStatus',
    invalidMailingAddress: 'Invalid character in mailing address',
    invalidCity: 'Invalid character in resiCity',
    invalidCompName: 'Invalid character in companyName',
    invalidDesignation: 'Invalid character in designation'
}

export const TOOLTIPS = {
    firstNameTooltip: 'Enter name as per your pancard.',
    autocompleteTooltip: 'Start typing',
    occupationTooltip: 'Select Source of Income'
}
export const HEADER_SECTION = {
    headerText: 'You are applying for',
    card_name: 'SBI Card Elite Advantage',
    changeCardText: 'Change Card',
    cardBenefits: 'Card Benefits:',
    welcome_text_1: 'Welcome e-Gift Voucher worth Rs. 3,000 on joining.',
    welcome_text_2: 'Spend linked Gift Vouchers worth Rs. 11,000.',
    welcome_text_3: '10 Reward Points per Rs. 100 spent on Dining, Groceries, Departmental stores and Movies.'

}
export const HEADER_TEXT = 'You are applying for'
export const ACCOUNT_NO_SBI = 'Enter your account number related with State Bank of India'
export const SCHEDULE_APPOINTMENT = {
    uploadDoc: 'Upload all the documents online for faster processing and earn gift vouchers.',
    goToDocUpload: 'Go to Document Upload',
    alreadySchApp: 'Your have already scheduled an appointment with us on',
    prefferredLoc: 'Preferred location is your',
    officeLoc: 'Office',
    currentLoc: 'Current Address',
    perLoc: 'Permanent Address',
    docUploadSuccess: 'Documents Successfully Uploaded',
    successMsg: 'Please book your appointment to get your KYC done with our SBI Card excutive.',
    docUploadPending:'Documents Pending',
    pendingMsg: 'Upload all the documents online to earn gift voucher. You can retrieve your application using your interaction ID and upload your documents.'
}
export const RETRIEVE_POPUP = {
    popup_heading: 'It seems you already have an application in progress?',
    popup_content: 'An ongoing credit card application under your name already exists. You can choose to retrieve your existing application or continue with the new application.',
    popup_action: 'Continue with the new Application'
}
export const ADD_ON = 'Add-on Card'
export const REFER_TEXT = 'You can refer upto 3 member'
export const PROGRESS_BAR = {
    submit_text: 'Submit the complete application online and earn exciting offers.',
    appComplete_text: 'Application Completed'
}
export const SUCCESS_PAGE_TEXT = 'You will receive your Applied card at your preffered adderess'
export const TRACK_APP = {
    welcome_heading: 'One Time Verification',
    welcomeHeadingSbiCard:'One time Verification for your SBI Card Application',
    welcomeHeadingTataCard:'One time Verification for your Tata Card Application',
    otp_text: 'Enter the six digit code sent on your mobile number',
    otpResend: 'Your OTP has been resent',
    resendCode: 'Resend Code',
    trackError: 'SBI Card credentials as entered by you are incorrect. Please try again or call up the SBI Card helpline on 39 02 02 02 (prefix your city code) or 1860 180 1290, 1800 180 1290 (only for MTNL and BSNL users)',
    trackErrorTata: 'TATA Card credentials as entered by you are incorrect. Please try again or call up the SBI Card helpline on 39 02 02 02 (prefix your city code) or 1860 180 1290, 1800 180 1290 (only for MTNL and BSNL users)',
    //trackError: trackError
    //Digitracking Card Track -> shordcode message flag
    DIGITRACK_SHORTCODE_EXPIRED_MSG : 'Sorry! The link you are trying to access is invalid.',
    DIGITRACK_SHORTCODE_FAILURE_MSG : 'Something went wrong! Please click on the link in the SMS again.',
    digitaltrack_shortcode_otp_text: 'Please enter the OTP sent on your Registered Mobile Number',
    digitaltrack_shortcode_generate_otp: 'Generate OTP',
}
export const CATALOG_VERBIAGE = {
    incorrectUrl:'URL entered by you is incorrect. Please try again with different url.',
    partnerExpiryError: 'The contract with SBICARD has been expired. Please contact your admin.'
}
export const DIGITAL_TRACK_APP = {
    carddelivered_heading1: 'Your SBI Card Is',
    carddelivered_heading2: 'Delivered To You!',
    carddeclined_heading1: 'Sorry! Your SBI Card',
    carddeclined_heading2: 'Application Is Declined!',
    cardapproved_heading1: 'Your SBI Card Application',
    cardapproved_heading2: 'Is Approved!',
    cardintrasit_heading1: 'Your SBI Card Is',
    cardintrasit_heading2: 'On The Way!',
    cardrto_heading: 'Returned to Origin',
    cardDeliveryStatus_heading1: 'Track Your SBI Card',
    cardDeliveryStatus_heading2: 'Delivery!',
    cardupdateDeliveryStatus_heading1: 'Reschedule Delivery',
    // cardupdateDeliveryStatus_heading2: 'Instructions!',

    cardheader_title1: 'Application Number',
    cardheader_title2: 'Courier Name',
    cardheader_title3: 'AWB Number',
    cardheader_title4: 'Est. Delivery Date',

    trackappcard_tabtitle1: 'Application Status Journey',
    trackappcard_tabtitle2: 'Track Your Card Delivery',
    trackappcard_tabtitle3: 'Reschedule Delivery',
}
// export const GENERIC_ERROR = 'Error occured, Please try after some time.';

//credential Addition start
export const ENV_CREDENTIAL = {
    channel : {channel: "sprint"}
}
//credential Addition end

//Theme object
export const SBICARDTheme = {
    'partner_id': 'sbi',
    'primary-color': '#0095d9',
    'background-color': '#fff',
    'text-color': '#000',
    'font-size': '14px',
    //'font-family':"'Roboto', sans-serif",
    'header-color': '#181818',
    'pagination-color': '#0095d9',
    'content-color': '#3d3d3d',
    'button-color': '#26c5ff',
    'page-header': '#1f1f1f',
    'label-color': '#999999',
    'radio-button-color': '#02b1f2',
    'placeholder-color': '#0095d9',
    'input-border-bottom': '#0095d9',
    'checkbox-color': '#02b1f2',
    'border-color': '#0095d9',
    'image-color': '#0095d9', 
   // 'progressbar-color': 'linear-gradient(172deg,#61b72f,#25a624)',
    'otp-label-color': '#0095d9',
    'dropdown-background-color': '#fff',
    'input-border': '#0095d9',
    'link-color': '#02b1f2',
    "toggle-button-color": "#02b1f2",
    'background-color-addon': '#f5f5f5',
    'primary-theme-color': '#00b1f2',
    'header-color-addon': 'white',
    'text-color-addon': '#8a8a96',
    'border-color-addon': '#f5f5f5',
    'background-color-addon-subheading': '#f2f7fd',
    'text-color-addon-subheading': '#2d2d2d',
    'label-color-addon':'#a8a8a8',
    'background-color-addon-div': 'rgb(242, 242, 253)',
    'disable-link-color-addon': 'grey',
    'disable-heading-color-addon': 'black',
    'text-color-catalogue-subblock': '#323232',
    'text-color-comp-add': '#2d2d2d',
    'mat-radio-out-color': '#8a8a96',
    'border-color-comp-add': '#f2f2fd',
    'mat-header-border-comp-add': '#f2f9f2',
    'label-color-comp-add': '#2d2d2d',
    'border-color-panel': '#000',
    'error-msg-color-comp-add': 'red',
    'card-subtitle-color-comp': 'rgba(132, 127, 127, 0.54)',
    'text-color-comp-per': ' #8a8a96',
    'modten-color': '#ff0000',
    'popup-heading-color': 'rgba(0,0,0,.87)',
    'bottom-link-color-comp': '#f2f7fd',
    'anchor-btn-color-comp': 'transparent',
    'terms-text-color-comp': 'rgb(214, 214, 214)',
    'refer-text-color': '#757575',
    'box-shadow-doc': 'rgba(0, 0, 0, 0.16)',
    'background-color-doc': '#ffffff',
    'text-color-doc': '#2d2d2d',
    'mobile-field-bgc-qde': '#a9a9a9',
    'card-label-color-qde': '#dbdbdb',
    'label-font-color-qde': 'rgba(0, 0, 0, 0.54)',
    'background-color-qde': '#f2f7fd',
    'label-color-qde': '#2d2d2d',
    'mat-card-color-qde': '#8a8a96',
    'border-color-qde': '#666666',
    'circle-color-qde': '#ffffff',
    'background-color-qde-existing': 'white',
    'border-color-mob-qde': '#f2f2fd',
    'background-success-msg-qde': '#ebf9ff',
    'mat-dialog-border': '#dadada',
    'text-decoration-otp': 'dodgerblue',
    'error-msg-color-qde': 'red',
    'border-top-stepper': '#efe5e5',
    'mat-card-subtitle-color': 'rgba(132, 127, 127, 0.54)',
    'textColor' : '#222',
    'fontSize' : '12px',
    'spa-font-family': `'Open Sans',sans-serif`,
    'spa-font-style': 'normal',
    'mat-focus-color': 'pink',
    'mat-input-font': 'sans-serif',
    'mat-form-label': 'black',
    'mat-ripple-color': 'white',
    'error-msg-global': 'red',
    'backdrop-color': 'rgba(255, 255, 255, 0.7)',
    'backdrop-color-mob': 'white',
    'mat-form-invalid': '#f44336',
    'mat-mini-fab-color': '#26c5ff',
    'mat-text-color': '#2d2d2d',
    'mobile-heading-color':'#8a8a96',
    'nav-bar-color': '#ffffff',
    'circle-color-pg': '#d5d5ea',
    'line-color-pg': '#d5d5ea',
    'line-color-dis-pg': '#d5d5ea',
    'secondary-theme-color': '#02b1f2',
    'date-disabled-background':'lightgrey',
    'date-selected-color':'#fff',
    'line-color': '#12aae8',
    'mat-chip-color': 'grey',
    'mat-chip-background': 'white',
    'mat-error-color': '#f74747',
    'success-page-color': 'green',
    'nav-bar-track': '#f2f7fd',
    'selection-color-background':'#0095d9',
    'selection-color-text': '#fff',
    'container-width': '480px',
    'card-background': '#fff',
    'button-text-color': '#fff',
    'heading-color': '#000',
    'button-border-radius': '53px',
    "mat-heading-color": "rgba(0, 0, 0, 0.87)",
    'form-background': '#f5f5f5',
    'mat-dropdown-color': '#F2F7FD',


    //Aurum changes
    'top-header-color': '#fff',
    'mat-cards-title': '#2d2d2d',
    'mat-label-color': 'rgba(0,0,0,0.54)',
    'mat-label-underline': 'rgba(0, 0, 0, 0.42)',
    'mat-otp-button-label': '#fff',
    'mat-otp-button-background': '#DADADA',
    'mat-hint-color': 'rgba(0,0,0,.6)',
    'mat-heading-color-disabled': 'rgba(0,0,0,.54)',
    'mat-dropdown-option-color': '#fff',
    'disabled-toggle-color' : 'rgba(0,0,0,.38)',
    'input-backgroud-color' : '#fff',
//   'disabled-text-color' : 'rgba(0,0,0,.38)'
//   'disabled-text-color' : 'green',
    'add-card-feature-text-color': '#2d2d2d',
    'text-color-addon-heading' : '#000',
    'addon-form-background': '#fff',
    'mat-datepicker-background':'#fff',
    'mat-datepicker-text-color':'#000',
    'mat-calendar-arrow-border':'rgba(0,0,0,.26)',
    'mat-calendar-previous-button-color':'rgba(0,0,0,.54)',
    'mat-warn-disabled-color':'rgba(0,0,0,.26)',
    'mat-calendar-table-header-color':'#000',
    'mat-calendar-body-label-color':'#000',
    'mat-calendar-body-cell-content-color': '#000',
    'mat-calendar-body-cell-content-border-color': '#fff',
    'mat-calendar-body-selected-color' :'rgba(0,0,0,.54)',
    'cardholder-label-color' : '#fff',
    'mat-slider-color' : '#f5f5f5',
    'mat-slider-color-hover' : 'rgba(0,0,0,.38)',
    'mat-slider-border' : '#f5f5f5'

};


export const IMAGEUrl = [{
    'image-url' : '',
    'image-label' : ''

}];
// new endpoint changes to be done as follows 

export const GENERATE_OTP_URL = `${base_https_url}/api-gateway/resource/d2i/otp/generate`;
export const VALIDATE_OTP_URL = `${base_https_url}/api-gateway/resource/d2i/otp/validate`;
export const VALIDATE_QDE_OTP_URL = `${base_https_url}/api-gateway/resource/d2i/otp/validate-ds`;
// export const CREATE_LEAD_URL = `${base_https_url}/api-gateway/resource/eapply/generate-eapply-lead`;
// export const SUBMIT_QDE_URL = `${base_https_url}/api-gateway/resource/eapply-api/qde/qde-submit`;
 //new context path added for testing of refer and earn starts
export const CREATE_LEAD_URL = `${base_https_url}/api-gateway/resource/eapply/generate-eapply-lead`;
export const SUBMIT_QDE_URL = `${base_https_url}/api-gateway/resource/eapply-api/qde/qde-submit`;
export const SUBMIT_EXISTING_CUST = `${base_https_url}/api-gateway/resource/eapply-api/existing/save-details`;
export const SAVE_UPDATE_APPLICATION = `${base_https_url}/api-gateway/resource/eapply-api/app/save-update-application`;
export const SUBMIT_COMPLETE_APP = `${base_https_url}/api-gateway/resource/eapply-api/dc/data-capture`;
export const SUBMIT_REFERRAL_URL = `${base_https_url}/api-gateway/resource/eapply-api/referral/save`;
export const PAN_NAME_MISMATCH_URL = `${base_https_url}/api-gateway/resource/eapply-api/pan-name-check`;
export const PAN_DEDUPE_URL = `${base_https_url}/api-gateway/resource/eapply-api/dedupe/pan-dedupe-check`;
export const UPSELL_DOWNSEll_OFFER = `${base_https_url}/api-gateway/resource/eapply-api/sell/upsell-downsell`;
// export const FETCH_MASTER_URL = `${base_https_url}/EapplyMasterDataService/eapply/generate-eapply-data`;
export const FETCH_MASTER_URL = `${base_https_url}/api-gateway/resource/eapply-api/EapplyMasterDataService/eapply/generate-eapply-data`;
export const FETCH_MASTER_URL1 = `${base_https_url}/api-gateway/resource/swiftapp/getMasterData`;
export const FETCH_APPOINTMENT_SLOT_URL = `${base_https_url}/api-gateway/resource/eapply-api/slot/fetch-appointment-slot`;
export const BOOK_APPOINTMENT_URL = `${base_https_url}/api-gateway/resource/eapply-api/appointment/book`;
export const TRACK_SR = `${base_https_url}/api-gateway/resource/eapply-api/trackapp/track-app`;
export const TRACK_APPLICATION_URL = `${base_https_url}/api-gateway/resource/eapply-api/trackapp/track-app `;
export const RETRIEVE_APPLICATION_URL = `${base_https_url}/api-gateway/resource/eapply-api/lead/retrieve`;
export const CROSS_SELL_URL = `${base_https_url}/api-gateway/resource/eapply-api/crosssell/cross-sell`;
export const ADDON_URL = `${base_https_url}/api-gateway/resource/eapply-api/addon/add-on`;
export const DCR_SBICARD_URL = `${base_https_url}/api-gateway/resource/eapply-api/cardDetails/fetch-sbicard-details?path=`;
export const DCR_TATACARD_URL = `${base_https_url}/api-gateway/resource/eapply-api/cardDetails/fetch-tatacard-details?path=`;
export const EXPAND_MINI_URL = `${base_https_url}/api-gateway/resource/eapply-api/docUpload/fetch-params`
export const VALIDATE_REFERRAL = `${base_https_url}/api-gateway/resource/managereferrals/validate-referral`;
export const ALL_CARD_JSON_DCR_XML = `${base_https_url}/content/cards/cardsjson.page`;
export const PARTNER_THEME = `${base_https_url}/services/resource/pi-eapply/PartnerTheme/fetchPartnerTheme`;
export const PARTNER_THEME_URL = `${base_https_url}/sbi-card-en/resources/css/theme-json/`;

//New changes for redirection
export const X_SBIC_COOKIE = fgpCookie;
export const GENERATE_NEW_RETRIEVE_OTP_URL = `${base_https_url}/api-gateway/resource/swiftapp/esb-otp-gen`;
export const GENERATE_NEW_TRACK_OTP_URL = `${base_https_url}/api-gateway/resource/swiftapp/newcard-lead-track-gen`;
export const GENERATE_NEW_TRACK_URL = `${base_https_url}/api-gateway/resource/swiftapp/newcard-lead-track-auth`;
export const GENERATE_NEW_RETRIEVE_URL = `${base_https_url}/api-gateway/resource/swiftapp/newcard-lead-retrieve`;
export const GENERATE_RETRIEVE_SHORTCODE_OTP_URL = `${base_https_url}/api-gateway/resource/swiftapp/c2b-retrieve-otp-gen`;
export const GENERATE_TOKEN_URL = `${base_https_url}/api-gateway/resource/oAuth/tokenGen?cname=`;
export const GENERATE_SHIPMENT_DELIVERY_URL = `${base_https_url}/api-gateway/resource/swiftapp/get-shipment-details`;
export const GENERATE_UPDATE_DELIVERY_URL = `${base_https_url}/api-gateway/resource/swiftapp/update-delivery-details`;
export const GENERATE_VALIDATE_SHORTCODE_URL = `${base_https_url}/api-gateway/resource/swiftapp/auth-otp-shortcode`;
export const GENERATE_NEW_OTP_URL_ENCRYPT = true;
export const RETRIEVE_AUTH_NEW_URL_ENCRYPT = true;
export const RETRIEVE_AUTH_NEW_URL_DECRYPT = true;
export const TRACK_GEN_NEW_URL_ENCRYPT = true;
export const TRACK_GEN_NEW_URL_DECRYPT = true;
export const RETRIEVE_GEN_OTP_DECRYPT = true;
export const ENCRYPT_FOR_TOKEN_CALL = true;
export const DECRYPT_FOR_TOKEN_CALL = true;
export const REDIRECT_SWIFT_URL = `${base_https_url}/sprint/`;
export const TRACK_GEN_NEW_DELIVERY_SHIPMENT_URL_ENCRYPT = true;
export const TRACK_GEN_NEW_SAVE_INSTRUCTION_URL_ENCRYPT = true;
export const TRACK_GEN_NEW_SHORTCODE_URL_ENCRYPT = true;
export const TRACK_GEN_NEW_SHORTCODE_URL_DECRYPT = true;
export const TRACK_GEN_SHIPMENT_RESPONSE_URL_DECRYPT = true;
export const TRACK_GEN_UPDATE_INSTRUCTION_URL_DECRYPT = true;
// export const REDIRECT_SWIFT_URL = `${base_https_url}/swift/`;

//Flags to enable Encryption
export const GENERATE_OTP_URL_ENCRYPT = true;
export const VALIDATE_OTP_URL_ENCRYPT = true;
export const VALIDATE_QDE_OTP_URL_ENCRYPT = true;
export const CREATE_LEAD_URL_ENCRYPT = true;
export const SUBMIT_QDE_URL_ENCRYPT = true;
export const SUBMIT_EXISTING_CUST_ENCRYPT = true;
export const SAVE_UPDATE_APPLICATION_ENCRYPT = true;
export const SUBMIT_COMPLETE_APP_ENCRYPT = true;
export const SUBMIT_REFERRAL_URL_ENCRYPT = true;
export const PAN_NAME_MISMATCH_URL_ENCRYPT = true;
export const PAN_DEDUPE_URL_ENCRYPT = true;
export const UPSELL_DOWNSEll_OFFER_ENCRYPT = true;
export const FETCH_MASTER_URL_ENCRYPT = true;
export const BOOK_APPOINTMENT_URL_ENCRYPT = true;
export const TRACK_SR_ENCRYPT = true;
export const TRACK_APPLICATION_URL_ENCRYPT = true;
export const RETRIEVE_APPLICATION_URL_ENCRYPT = true;
export const CROSS_SELL_URL_ENCRYPT = true;
export const ADDON_URL_ENCRYPT = true;
export const EXPAND_MINI_URL_ENCRYPT = true;
export const ENCRYPT_VALIDATE_REFERRAL = true;
//flags to enable decryption

export const GENERATE_OTP_URL_DECRYPT = false;
export const VALIDATE_OTP_URL_DECRYPT = true;
export const VALIDATE_QDE_OTP_URL_DECRYPT = true;
export const CREATE_LEAD_URL_DECRYPT = false;
export const SUBMIT_QDE_URL_DECRYPT = false;
export const SUBMIT_EXISTING_CUST_DECRYPT = false;
export const SAVE_UPDATE_APPLICATION_DECRYPT = false;
export const SUBMIT_COMPLETE_APP_DECRYPT = false;
export const SUBMIT_REFERRAL_URL_DECRYPT = false;
export const PAN_NAME_MISMATCH_URL_DECRYPT = false;
export const PAN_DEDUPE_URL_DECRYPT = false;
export const UPSELL_DOWNSEll_OFFER_DECRYPT = false;
export const FETCH_MASTER_URL_DECRYPT = false;
export const BOOK_APPOINTMENT_URL_DECRYPT = false;
export const TRACK_SR_DECRYPT = false;
export const TRACK_APPLICATION_URL_DECRYPT = true;
export const RETRIEVE_APPLICATION_URL_DECRYPT = true;
export const CROSS_SELL_URL_DECRYPT = false;
export const ADDON_URL_DECRYPT = false;
export const EXPAND_MINI_URL_DECRYPT = false;
export const DECRYPT_VALIDATE_REFERRAL = true;



